import {Button} from 'antd'
import {getId, getType} from 'apis/model/base'
import {partners_getPartners_Api} from 'apis/organizationPartner'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {compose, fromRenderProps} from 'recompose'
import {PartnersSortBy} from 'views/AppLocals/factory/createEntitySortBy'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper from 'views/AppLocals/hooks/usePaginationHelper'
import ListHeader from 'views/AppLocals/Templates/items/ListHeader'
import {usePartners} from 'views/Organization/Settings/Partners/UsePartners'
import {NullAsDefault} from 'views/Shared'
import CRUD from 'views/Shared/enums/CRUD'
import {renderPartner} from '../functions/renderPartner'
import OrganizationContainerContext from '../OrganizationContainerContext'
import {useRouteSearchParam} from "../../../../envs/_current/history";

const OrganizationSettingPartners = ({
                                       owner_id,
                                       owner_type,
                                       Wrapper = 'div',
                                       filter_actions = {
                                         sortBy: 'sort-by',
                                         keyword: 'keyword',
                                         partner_type: 'type',
                                       },
                                     }) => {
  const t = useTranslate()

  const sortBy = useRouteSearchParam(filter_actions.sortBy)

  const partner_type = useRouteSearchParam(filter_actions.partner_type)

  const {
    refreshKey,
    modal = null,
    renderContextMenu,
    handleAction = NullAsDefault,
  } = usePartners({
    organization_id: owner_id,
  })

  const [pager_widget] = usePaginationHelper({
    onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
      onFilterChange({
        partner_type,
      })
      onSortChange(sortBy)
    },
    pagerInfo: {
      apiInfo: partners_getPartners_Api,
      query: bindQueryParam({
        id: owner_id,
      }),
      renderItem: renderPartner({
        renderContextMenu,
      }),
      RenderEntity: React.Fragment,
    },
    withKey: ({sortBy, keyword, filterBy}) =>
      [
        sortBy,
        keyword,
        owner_id,
        owner_type,
        refreshKey,
        JSON.stringify(filterBy),
      ].join('/'),
    dependencies: [owner_id, owner_type],
    query_params: filter_actions,
    sortHeader: t('list of partners'),
    SortByWidget: PartnersSortBy,
    renderFilter: NullAsDefault,
    AdvancedFilter: NullAsDefault,
  })

  return (
    <Wrapper className="flex flex-col space-y-3">
      <ListHeader
        title="partners"
        extra={
          <Button
            className="button-rounded-lg no-border"
            type="primary"
            onClick={() => {
              handleAction(CRUD.CREATE)
            }}>
            {t('create')}
          </Button>
        }
      />
      {pager_widget}
      {modal}
      <div className="h-10"/>
    </Wrapper>
  )
}

export default compose(
  fromRenderProps(
    OrganizationContainerContext.Consumer,
    ({organization}) => ({
      owner_id: getId(organization),
      owner_type: getType(organization),
    })
  )
)(OrganizationSettingPartners)
